export const createMeta = vm => ({
  title: vm.$t('order.seo.title', { userName: vm.userInfo?.nickName }),
  meta: {
    pageTitle: { name: 'Page Title', content: vm.$t('order.seo.pageTitle', { userName: vm.userInfo?.nickName }), },
  },
})
